import React, { useState, useEffect } from "react";
import { Link, NavLink } from "react-router-dom";
import config from "../../config";
import { getLogout, role } from "../Actions/AuthAction";

const LeadSideBar = () => {
  return (
    <>
      <div id="layoutSidenav_nav">
        <nav
          class="sb-sidenav accordion sb-sidenav-light"
          id="sidenavAccordion"
        >
          <div class="sb-sidenav-menu">
            <a class="navbar-brand" href="index.html">
              <img
                src={`${config.DOMAIN_URL}/assets/img/logo.png`}
                class="logo"
              />
            </a>
            <div class="nav mt-5">
              <Link to="/" class="nav-link active">
                <div class="sb-nav-link-icon">
                  <i class="fas fa-life-ring"></i>
                </div>
                Company
              </Link>
              <Link to="/support" class="nav-link">
                <div class="sb-nav-link-icon">
                  <i class="fas fa-life-ring"></i>
                </div>
                Sell Old Laptop/Mobile
              </Link>
              <a
                class="nav-link collapsed"
                href="#"
                data-toggle="collapse"
                data-target="#collapseLayoutsSix"
                aria-expanded="false"
                aria-controls="collapseLayouts"
              >
                <div class="sb-nav-link-icon">
                  <i class="fa fa-life-ring" aria-hidden="true"></i>
                </div>
                Companies
                <div class="sb-sidenav-collapse-arrow">
                  <i class="fas fa-angle-down"></i>
                </div>
              </a>
              <div
                class="collapse"
                id="collapseLayoutsSix"
                aria-labelledby="headingOne"
                data-parent="#sidenavAccordion"
              >
                <nav class="sb-sidenav-menu-nested nav">
                  <Link to="/" className="nav-link">
                    Full Time Hiring
                  </Link>
                  <Link to="/" className="nav-link">
                    3rd Party Payroll/Employee Management
                  </Link>
                  <Link to="/" className="nav-link">
                    Contractual Staffing
                  </Link>
                  <Link to="/" className="nav-link">
                    Recruitment Process Outsourcings
                  </Link>
                  <Link to="/" className="nav-link">
                    Campus Placement Solution
                  </Link>
                </nav>
              </div>
            </div>
          </div>
          <div class="sb-sidenav-footer">
            <div class="small">Logged in as:</div>
            <span class="text-danger font-weight-bold">{role()}</span>
          </div>
        </nav>
      </div>
    </>
  );
};
export default LeadSideBar;
